import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Order from "./pages/Order"
import AddProduct from "./pages/AddProduct";
import EditProduct from "./pages/EditProduct";
import Contact from "./pages/Contact"
import Offer from "./pages/Offer";
import 'react-toastify/dist/ReactToastify.css';
import Customers from "./pages/Customer";
import Quotation from "./pages/Quotation";
import QuotationList from "./pages/QuotationList";
import Inventory from "./pages/Inventory";
import PurchaseOrder from "./pages/PurchaseOrder";
import Supplier from "./pages/Supplier";
import ProductReturn from "./pages/ProductReturn";
import Invoice from "./pages/Invoice";
import Settings from "./pages/Settings";
import MenuManagement from "./pages/MenuManagement";
import Login from "./Auth/Login"; 
import ProtectedRoute from "./Auth/ProtectedRoute"; 
import AdminAuthManager from "./Auth/AdminAuthManager";
import AIChat from "./components/AIChat";
import AIQuestionManager from "./components/AIQuestionManager";
import AICommandManager from "./components/AICommandManager";
import Attendance from "./pages/Attendance";
import Leave from "./pages/Leave";
import LiveTracking from "./pages/LiveTracking";
import Tracking from "./pages/Tracking";
import Expenses from "./pages/Expenses";
import CustomerVisit from "./pages/CustomerVisit";
import SalesDashboard from "./pages/SalesDashboard";
import SalesmanDashboard from "./pages/SalesmanDashboard";
import GSTReport from "./pages/GSTReport";
import CustomerMangement from "./pages/CustomerMangement";


function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />
      <BrowserRouter>
        <Routes>
          {/* 🔓 PUBLIC ROUTE: Edhavadhu user login seiyamal vandhal intha page mattumae theriya vendum */}
          <Route path="/login" element={<Login />} />

          {/* 🔒 PROTECTED CORE ROUTING MATRIX */}
          {/* User-kku token illai endral ProtectedRoute avargalai direct-aga /login-uku redirect seidhuvidum */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            {/* Index component matches pure base domain "/" */}
            <Route index element={<Dashboard />} />
            
            {/* Exact Admin Panel Content Target Paths */}
            <Route path="/Products" element={<Products />} />
            <Route path="/Order" element={<Order />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Offer" element={<Offer />} />
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/edit-product/:id" element={<EditProduct />} />
            <Route path="/Customers" element={<Customers />} />
            <Route path="/Quotation" element={<Quotation />} />
            <Route path="/QuotationList" element={<QuotationList />} />
            <Route path="/Inventory" element={<Inventory />} />
            <Route path="/PurchaseOrder" element={<PurchaseOrder />} />
            <Route path="/Supplier" element={<Supplier />} />
            <Route path="/ProductReturn" element={<ProductReturn />} />
            <Route path="/Invoice" element={<Invoice />} />
            <Route path="/Settings" element={<Settings />} />
            <Route path="/MenuManagement" element={<MenuManagement />} />
            <Route path="/adminAuthManager" element={<AdminAuthManager />} />
           <Route path="/ai" element={<AIChat />} />
           <Route path="/AIQuestionManager" element={<AIQuestionManager />} />
            <Route path="/AICommandManager" element={<AICommandManager />} />
             <Route path="/Attendance" element={<Attendance />} />
              <Route path="/Leave" element={<Leave />} />
               <Route path="/LiveTracking" element={<LiveTracking />} />
               <Route path="/Tracking" element={<Tracking />} />
                  <Route path="/Expenses" element={<Expenses />} />
                   <Route path="/CustomerVisit" element={<CustomerVisit />} />
                   <Route path="/CustomerMangement" element={<CustomerMangement />} />

                   {/* Dashboard */}
                   <Route path="/SalesDashboard" element={<SalesDashboard />} />
                   <Route path="/SalesmanDashboard" element={<SalesmanDashboard />} />
                       

                    {/* Report    */}
                    <Route path="/GSTReport" element={<GSTReport />} />


          </Route>

          {/* Fallback Catch: Vera edhavadhu random URL adithal login query state-ku move aaga */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;